// src/pages/Datenschutz.js

import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import './Datenschutz.css';

const Datenschutz = () => {
    useEffect(() => {
        document.title = 'TRAC - Datenschutzerklärung';
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="datenschutz-page">
            <Container className="datenschutz-container">
                <Row>
                    <Col>
                        <Link to="/" className="datenschutz-back-link">
                            ← Zurück
                        </Link>
                        
                        <h1 className="datenschutz-title">Datenschutzerklärung TRAC Tool</h1>

                        <section className="datenschutz-section">
                            <h2>1. Verantwortlicher</h2>
                            <p>Verantwortlich für die Datenverarbeitung:</p>
                            <p>
                                <strong>Firma:</strong> GPTW Deutschland GmbH<br />
                                <strong>Adresse:</strong> Im Klapperhof 7-23, 50670 Köln<br />
                                <strong>E-Mail:</strong> <a href="mailto:info@greatplacetowork.de">info@greatplacetowork.de</a><br />
                                <strong>Telefon:</strong> +49 221 / 93 335 – 0<br />
                                <strong>Fax:</strong> +49 221 / 93 335 – 100
                            </p>
                        </section>

                        <section className="datenschutz-section">
                            <h2>2. Datenschutzbeauftragter</h2>
                            <p>Kontaktdaten des Datenschutzbeauftragten:</p>
                            <p>
                                Daniel Schwaiger, isdacom GmbH, Forsbachstraße 19, 51145 Köln<br />
                                <strong>E-Mail:</strong> <a href="mailto:datenschutz@greatplacetowork.de">datenschutz@greatplacetowork.de</a>
                            </p>
                        </section>

                        <section className="datenschutz-section">
                            <h2>3. Zwecke und Rechtsgrundlagen der Verarbeitung</h2>
                            <p>Wir verarbeiten personenbezogene Daten zu folgenden Zwecken:</p>
                            <ul>
                                <li>Bereitstellung und Betrieb der SaaS-Dienstleistung (Vertragserfüllung, Art. 6 Abs. 1 lit. b DSGVO).</li>
                                <li>Erstellung von Nutzerkonten (Vertragserfüllung, Art. 6 Abs. 1 lit. b DSGVO).</li>
                                <li>Kommunikation mit Kundinnen/Kunden, z.B. bei Supportanfragen (Vertragserfüllung/berechtigtes Interesse, Art. 6 Abs. 1 lit. b/lit. f DSGVO).</li>
                            </ul>
                        </section>

                        <section className="datenschutz-section">
                            <h2>4. Kategorien personenbezogener Daten</h2>
                            <p>Je nach Nutzung erheben wir:</p>
                            <ul>
                                <li><strong>Basisdaten:</strong> Vorname, Nachname, E-Mail-Adresse, organisatorische Daten, Unternehmensname, Abteilung/Bereich, Berichtsstruktur</li>
                                <li><strong>Kontoinformationen:</strong> Rolle, Passwort (verschlüsselt).</li>
                                <li><strong>Nutzungs-/Logdaten:</strong> Zeitpunkt der Nutzung.</li>
                                <li><strong>Kommunikationsdaten:</strong> Support-Anfragen, E-Mails.</li>
                            </ul>
                        </section>

                        <section className="datenschutz-section">
                            <h2>5. Empfänger oder Kategorien von Empfängern</h2>
                            <p>Daten können übermittelt werden an:</p>
                            <ul>
                                <li>Hosting-Provider (Hetzner Online) — als Auftragsverarbeiter.</li>
                            </ul>
                            <p>Wir schließen mit allen Dienstleistern Auftragsverarbeitungsverträge gemäß Art. 28 DSGVO.</p>
                        </section>

                        <section className="datenschutz-section">
                            <h2>6. Übermittlung in Drittländer</h2>
                            <p>Falls Daten in Drittstaaten außerhalb der EU/des EWR übertragen werden (z. B. USA), greifen geeignete Garantien:</p>
                            <ul>
                                <li>Standardvertragsklauseln (SCC) oder</li>
                                <li>Angemessenheitsentscheidung der EU-Kommission.</li>
                            </ul>
                        </section>

                        <section className="datenschutz-section">
                            <h2>7. Speicherdauer</h2>
                            <p>Daten werden nur so lange gespeichert, wie es für die Bereitstellung des SaaS-Dienstes erforderlich ist. Auf Wunsch können personenbezogene Daten der Benutzer oder Kunden gelöscht oder anonymisiert werden, ohne dass dies die Integrität der Geschäftsdaten beeinträchtigt.</p>
                            <p>Aktive Benutzerdaten werden so lange gespeichert, wie das Benutzer-/Unternehmenskonto aktiv ist.</p>
                        </section>

                        <section className="datenschutz-section">
                            <h2>8. Rechte der betroffenen Personen</h2>
                            <p>Betroffene Personen haben u. a. folgende Rechte:</p>
                            <ul>
                                <li>Auskunft über verarbeitete Daten (Art. 15 DSGVO).</li>
                                <li>Berichtigung unrichtiger Daten (Art. 16).</li>
                                <li>Löschung („Recht auf Vergessenwerden", Art. 17), sofern keine rechtlichen Aufbewahrungspflichten bestehen.</li>
                                <li>Einschränkung der Verarbeitung (Art. 18).</li>
                                <li>Widerspruch gegen Verarbeitung aus berechtigtem Interesse (Art. 21).</li>
                                <li>Datenübertragbarkeit (Art. 20).</li>
                            </ul>
                            <p>Zur Ausübung der obengenannten Betroffenenrechte kann eine entsprechende E-Mail an <a href="mailto:datenschutz@greatplacetowork.de">datenschutz@greatplacetowork.de</a> gesendet werden. Darüber hinaus besteht ein Beschwerderecht bei der zuständigen Aufsichtsbehörde (LDI NRW).</p>
                        </section>

                        <section className="datenschutz-section">
                            <h2>9. Sicherheit der Verarbeitung</h2>
                            <p>Wir setzen technische und organisatorische Maßnahmen nach Stand der Technik ein, z. B.:</p>
                            <ul>
                                <li>HTTPS-/TLS-Verschlüsselung für Datenübertragung.</li>
                                <li>Verschlüsselte Speicherung von Daten.</li>
                                <li>Rollenbasierte Rechtevergabe.</li>
                                <li>Regelmäßige Backups.</li>
                            </ul>
                        </section>

                        <section className="datenschutz-section">
                            <h2>10. Cookies und Tracking</h2>
                            <p>Folgende Cookies werden verwendet:</p>
                            <ul>
                                <li>Ausschließlich technisch notwendige Cookies für Betrieb und Sicherheit.</li>
                            </ul>
                        </section>

                        <section className="datenschutz-section">
                            <h2>11. Auftragsverarbeitung</h2>
                            <p>Liste der AV-Partner mit Funktion und Link zu deren Datenschutzinformationen:</p>
                            <ul>
                                <li><strong>Hosting:</strong> Hetzner Online — <a href="https://www.hetzner.com/de/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Datenschutzhinweise</a></li>
                                <li><strong>E-Mail/Support:</strong> GPTW Deutschland (intern) — <a href="https://greatplacetowork.de/datenschutz/" target="_blank" rel="noopener noreferrer">Datenschutzhinweise</a></li>
                            </ul>
                        </section>

                        <section className="datenschutz-section">
                            <h2>12. Änderungen der Datenschutzerklärung</h2>
                            <p>Wir passen die Datenschutzerklärung bei Bedarf an. Das Datum der letzten Änderung: <strong>02.02.2026</strong>. Bei wesentlichen Änderungen informieren wir Nutzer separat.</p>
                        </section>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </div>
    );
};

export default Datenschutz;
